import React from "react";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoCloseCircleOutline } from "react-icons/io5";
export default function KnowMore({ popUpInitialValue, handlePopup }) {
  const { PopupStore, UserStore } = useStores();

  const closeThisPopUP = () => {
    PopupStore.setKnowMore(false);
    handlePopup();
  };
  return useObserver(() => (
    <>
      {popUpInitialValue ? (
        
        // <div className="h-[97vh] overflow-hidden">
        <div onClick={() => closeThisPopUP()} 
        className="fixed w-screen h-[105vh] z-[51] top-0 left-0 backdrop-filter backdrop-blur-sm bg-black overflow-hidden bg-opacity-40">
          <div onClick={(e) => e.stopPropagation()} className="fixed  inset-0 bg-bg3 z-[51] flex flex-col justify-center rounded-xl items-center overflow-hidden md:w-[35%] lg:w-[35%] w-[90%] h-[80vh] m-auto shadow-lg ">
            <div className="flex flex-col  items-center w-[100%] h-full overflow-y-auto no-scrollbar">
              <IoCloseCircleOutline
                className="text-primary absolute text-2xl lg:text-4xl cursor-pointer  top-2 right-2"
                onClick={closeThisPopUP}
              />
              <div className=" lg:text-2xl">
                <p className="text-xl gil-med bg-black !h-[10vh] text-white flex flex-row pt-3 justify-center  gap-2 items-center">
                  {" "}
                  <AiOutlineInfoCircle /> Know about Credit Points
                </p>

                <p className="mt-10 text-start px-10 ">
                  <h1 className=" mt-2 text-lg font-semibold lg:text-2xl">
                    What Are Credit Points?
                  </h1>
                  <p className="mb-5">
                    Credit points are like tokens you use to access mock
                    interviews on our platform. When you want to practice your
                    interview skills, you spend some of these credits. Think of
                    them as the currency for your interview preparation.
                  </p>
                  <h1 className=" mt-2 text-lg font-semibold lg:text-2xl">
                    How Do They Work?
                  </h1>
                  <p className="mb-5">
                    Each mock interview session costs 100 credit points. So,
                    when you initiate a mock interview, we deduct 100 credits
                    from your balance. It's that simple!
                  </p>
                  <h1 className=" mt-2 text-lg font-semibold lg:text-2xl">
                    What About Courses?
                  </h1>
                  <p className="mb-5">
                    Don't worry; you won't need credits for enrolling in courses
                    or accessing any other resources. Courses are always
                    available to help you learn without spending any credits.
                  </p>
                </p>
              </div>
            </div>
          </div>
        </div>
        // </div>
      ) : null}
    </>
  ));
}
